export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "es_utm";

export const captureUtm = () => {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const found = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 120);
  });
  if (params.get("fbclid")) found.utm_source = found.utm_source || "facebook";
  if (Object.keys(found).length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
};

export const getUtm = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch (e) {
    return {};
  }
};
